/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  
  if ($('.new_contact_form').length === 0) { return; }
    
  // disable the submit button when click to prevent double submission
  $('.new_contact_form').on('submit', function() {
    return $('.new_contact_form input[type=submit]').prop('disabled', true);
  });
    
  // re-enable the submit button on ajax:error
  return $(document).on('ajax:error', function() {
    return $('.new_contact_form input[type=submit]').prop('disabled', false);
  });
});
